export default {"src":"/_next/static/media/section5-icon2.a8c53e83.svg","height":58,"width":57,"blurWidth":0,"blurHeight":0};